export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none",
          },
          fontWeight: 700,
          [theme.breakpoints.down("sm")]: {
            padding: "4px 8px",
            // fontSize: "1.5rem",
          },
        },
        sizeLarge: {
          fontSize: 26,
          [theme.breakpoints.down("sm")]: {
            fontSize: 20,
          },
          height: 48,
        },
        // contained
        containedInherit: {
          // color: theme.palette.grey[800],
          color: theme.palette.text.secondary,
          //   color: "red",
          boxShadow: theme.customShadows.z8,
          "&:hover": {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          boxShadow: theme.customShadows.primary,
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary,
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
